(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('salesPointForm', {
            bindings: {
                store: '<',
                salesPoint: '<',
                onExpose: '&',
                onClose: '&'
            },
            controller: SalesPointFormController,
            controllerAs: 'vm',
            templateUrl: 'app/admin/store-management/sales-point-form/sales-point-form.html'
        });

    /** @ngInject */
    function SalesPointFormController($scope, $rootScope, GoogleMapsService) {
        var vm = this;

        vm.$onInit = function () {
            initModel();
            syncAddressModelToPointlocation();
            if (vm.onExpose) {
                vm.onExpose({
                    methods: {
                        closeModal: vm.closeModal,
                        isFormInvalid: vm.isFormInvalid,
                        save: vm.save
                    }
                });
            }
        };

        function initModel() {
            if (vm.salesPoint && vm.salesPoint.pointlocation) {
                vm.pointlocation = angular.copy(vm.salesPoint.pointlocation);
                vm.addressModel = {
                    zipcode: vm.pointlocation.postalCode || '',
                    address: vm.pointlocation.address || '',
                    addressNumber: vm.pointlocation.number || '',
                    district: vm.pointlocation.neighborhood || '',
                    complement: '',
                    city: vm.pointlocation.city || '',
                    state: vm.pointlocation.state || '',
                    country: vm.pointlocation.country || ''
                };
                vm.previousZipCode = (vm.pointlocation.postalCode || '').trim();
                vm.isEditMode = true;
            } else {
                vm.pointlocation = {
                    name: (vm.store && vm.store.name) ? vm.store.name : '',
                    contactPhone: (vm.store && vm.store.contactPhone) ? vm.store.contactPhone : '',
                    postalCode: '',
                    address: '',
                    number: '',
                    neighborhood: '',
                    city: '',
                    state: '',
                    country: ''
                };
                vm.addressModel = {
                    zipcode: '',
                    address: '',
                    addressNumber: '',
                    district: '',
                    complement: '',
                    city: '',
                    state: '',
                    country: ''
                };
                vm.previousZipCode = '';
                vm.isEditMode = false;
            }
        }

        function syncAddressModelToPointlocation() {
            $scope.$watch('vm.addressModel', function (newVal) {
                if (newVal && vm.pointlocation) {
                    vm.pointlocation.postalCode = newVal.zipcode;
                    vm.pointlocation.address = newVal.address;
                    vm.pointlocation.number = newVal.addressNumber;
                    vm.pointlocation.neighborhood = newVal.district;
                    vm.pointlocation.city = newVal.city;
                    vm.pointlocation.state = newVal.state;
                    vm.pointlocation.country = newVal.country;
                }
            }, true);
        }

        vm.isFormInvalid = function () {
            return vm.salesPointForm && vm.salesPointForm.$invalid;
        };

        vm.closeModal = function () {
            if (vm.onClose) {
                vm.onClose();
            }
        };

        vm.save = function () {
            vm.salesPointForm.$setSubmitted();
            if (vm.salesPointForm.$invalid) {
                return;
            }
            var pointData = angular.copy(vm.pointlocation);
            var point = {
                pointlocation: pointData,
                latitude: 0,
                longitude: 0
            };
            if (vm.isEditMode && vm.salesPoint && vm.salesPoint.id) {
                point.id = vm.salesPoint.id;
                point.pointlocation.id = vm.salesPoint.pointlocation.id;
            }

            var existingLat = vm.isEditMode && vm.salesPoint ? vm.salesPoint.latitude : null;
            var existingLng = vm.isEditMode && vm.salesPoint ? vm.salesPoint.longitude : null;

            var addressStr = buildAddressString(pointData);
            if (addressStr.trim()) {
                GoogleMapsService.getAddress(addressStr).then(function (response) {
                    if (response && response.geometry && response.geometry.location) {
                        var loc = response.geometry.location;
                        point.latitude = typeof loc.lat === 'function' ? loc.lat() : loc.lat;
                        point.longitude = typeof loc.lng === 'function' ? loc.lng() : loc.lng;
                    } else if (existingLat != null && existingLng != null) {
                        point.latitude = existingLat;
                        point.longitude = existingLng;
                    }
                    broadcastAndClose(point);
                }).catch(function () {
                    if (existingLat != null && existingLng != null) {
                        point.latitude = existingLat;
                        point.longitude = existingLng;
                    }
                    broadcastAndClose(point);
                });
            } else {
                if (existingLat != null && existingLng != null) {
                    point.latitude = existingLat;
                    point.longitude = existingLng;
                }
                broadcastAndClose(point);
            }
        };

        function buildAddressString(pl) {
            var parts = [
                pl.number,
                pl.address,
                pl.neighborhood,
                pl.city,
                pl.state,
                pl.postalCode,
                pl.country
            ].filter(Boolean);
            return parts.join(', ').replace(/undefined/g, '').replace(/null/g, '');
        }

        function broadcastAndClose(point) {
            if (vm.isEditMode && vm.salesPoint && vm.salesPoint.id) {
                $rootScope.$broadcast('salesPointUpdated', point);
            } else {
                $rootScope.$broadcast('salesPointCreated', point);
            }
            vm.closeModal();
        }
    }
})();
